import type { ComputedRef, Component, Ref } from 'vue';

import type { usePinFlow } from '../composables/usePinFlow';

export type TypeBlackPinItem = {
  pin: string | number;
  message: string;
};

export type TypePinMessages = {
  notConsecutiveText: string;
  notDescendingConsecutiveNumbers: string;
  notEqualsNumbers: string;
};

export interface IVerifyPinParams {
  pin: string | number;
  length: number;
  blacklist: TypeBlackPinItem[];
  messages: TypePinMessages;
}

export interface IPutPinByWorkflow {
  oldPin?: string;
  pin: string;
  businessFlow?: string;
  workflowExecutionId: string;
}

// CREATION
export enum PinCreateStep {
  CREATE = 'create',
  SUCCESS = 'success',
}

export enum PinRestoreStep {
  PIN = 'PIN',
  VERIFICATION = 'VERIFICATION',
}

// PIN FLOW
export enum PinType {
  'CREATE' = 'PinCreate',
  'RESET' = 'PinRestore',
  'VALIDATE' = 'PinValidate',
  'CHANGE' = 'PinRestoreCode',
}

export interface IShowPin {
  pinType: PinType;
  pinTitle?: string;
  pinDescription?: string;
  pinButtonPrimary?: string;
  isSignIn?: boolean;
}

export interface PinEmits {
  (e: 'close'): void;
}

export interface PinRestoreNavigation {
  getCurrentPath: () => string;
  goToMovements: () => void;
}

export interface PinRestoreProvider {
  step: Ref<PinRestoreStep>;
  currentPin: Ref<string>;
}

export interface UsePinRestoreReturn {
  step: Ref<PinRestoreStep>;
  isVerificationOpen: ComputedRef<boolean>;
  verificationAttempt: Ref<number>;
  handleRightHeader: () => void;
  onVerified: (workflowExecutionId: string) => Promise<void>;
  onCancelVerification: () => void;
  PinRestoreStep: typeof PinRestoreStep;
}

export interface PinRestoreCodeField {
  value: string;
  complete: boolean;
  error: string;
}

export interface UsePinRestoreCodeReturn {
  pin: PinRestoreCodeField;
  repeat: PinRestoreCodeField;
  isDisabled: ComputedRef<boolean>;
  isTypeChange: ComputedRef<boolean>;
  getTitleText: () => string;
  getSubtitleText: () => string;
  onClose: () => void;
  onKeyPressToValidate: () => void;
  onCompletePin: (isComplete: boolean) => void;
  onChangePin: (value: string) => void;
  onCompletePinRepeat: (isComplete: boolean) => void;
  onChangePinRepeat: (value: string) => void;
  onNext: () => Promise<void>;
}

export interface UsePinReturn {
  pinFlow: ReturnType<typeof usePinFlow>;
  zIndex: Ref<number>;
  currentComponent: ComputedRef<Component>;
  onClose: () => void;
}
